import { Provider } from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { enUS } from 'date-fns/locale';
import { settingsDateFormats } from './material.constants';
import { SettingsDateAdapter } from './settings-date-adapter';

/**
 * Angular Material app-wide providers. Standalone components import the
 * individual Material modules/directives they need directly; only these
 * cross-cutting providers (date adapter, date formats, dialog defaults) need to
 * be registered at the application level.
 */
export function provideAppMaterial(): Provider[] {
  return [
    { provide: MAT_DATE_LOCALE, useValue: enUS },
    ...provideDateFnsAdapter(),
    // Both registered after the adapter's own entries so these win: the
    // formats follow the user's `dateStyle` and the adapter's first day of the
    // week follows `calendarFirstDay`, neither of which a static value can read.
    { provide: DateAdapter, useClass: SettingsDateAdapter },
    { provide: MAT_DATE_FORMATS, useFactory: () => settingsDateFormats() },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: 'app-modal-overlay-panel',
      },
    },
  ];
}
